module.exports = __webpack_public_path__ + "img/indent.0d3502b5.svg";